/** Keys used by the persistence layer (localStorage, sessionStorage, IndexedDB). */
export const STORAGE_KEYS = {
    /** @deprecated Use DRAFT_SESSION_LIST instead. Kept for migration from single draft to list. */
    DRAFT_SESSION: 'custom_shape_draft',
    /** New key for storing array of draft entries. */
    DRAFT_SESSION_LIST: 'custom_shape_drafts',
    DRAFT_DB_NAME: 'custom_shape_db',
    /** DB version; bump when adding new object stores so onupgradeneeded runs and creates them. */
    DRAFT_DB_VERSION: 2,
    DRAFT_DB_STORE: 'draft_previews',
    DRAFT_IMAGES_STORE: 'draft_images',
    /** All object store names in the draft DB (used when opening/upgrading the DB). */
    DRAFT_DB_STORES: ['draft_previews', 'draft_images'],
    /** Key used to pass custom shape mapping payload from create-custom-shape to Step 2 editor. */
    CUSTOM_SHAPE_MAPPING_PAYLOAD: 'custom_shape_mapping_payload',
}
